module.exports = __webpack_public_path__ + "static/media/download.5b2ebcf6.svg";